<template>
    <div style="margin-bottom:50px">
        <div class="tit-head">
            <div>单选题</div>
            <!-- <div class="stem" v-html="info.title"></div> -->
            <mavonEditor 
                :boxShadow="false" 
                styleEditor="min-height: 20px;width: auto;" 
                :content="info.title" 
                :subfield="false" 
                :toolbarsFlag="false" 
                previewBackground="#fff"
                defaultOpen="preview" 
            />
        </div>
        
        <div class="single">
            <Radio-group v-model="info.yourAnswer" vertical @on-change="change">
                <Radio :label="'A'">
                    <div>A、</div>
                    <mavonEditor 
                        :boxShadow="false" 
                        styleEditor="min-height: 20px;width: auto;" 
                        :content="info.optionsA" 
                        :subfield="false" 
                        :toolbarsFlag="false" 
                        previewBackground="#fff"
                        defaultOpen="preview" 
                    />
                </Radio>
                <Radio :label="'B'">
                    <div>B、</div>
                    <mavonEditor 
                        :boxShadow="false" 
                        styleEditor="min-height: 20px;width: auto;" 
                        :content="info.optionsB" 
                        :subfield="false" 
                        :toolbarsFlag="false" 
                        previewBackground="#fff"
                        defaultOpen="preview" 
                    />
                </Radio>
                <Radio :label="'C'">
                    <div>C、</div>
                    <mavonEditor 
                        :boxShadow="false" 
                        styleEditor="min-height: 20px;width: auto;" 
                        :content="info.optionsC" 
                        :subfield="false" 
                        :toolbarsFlag="false" 
                        previewBackground="#fff"
                        defaultOpen="preview" 
                    />
                </Radio>
                <Radio :label="'D'" v-if="info.optionsD">
                    <div>D、</div>
                    <mavonEditor 
                        :boxShadow="false" 
                        styleEditor="min-height: 20px;width: auto;" 
                        :content="info.optionsD" 
                        :subfield="false" 
                        :toolbarsFlag="false" 
                        previewBackground="#fff"
                        defaultOpen="preview" 
                    /></span>
                </Radio>
                <Radio :label="'E'" v-if="info.optionsE">
                    <div>E、</div>
                    <mavonEditor 
                        :boxShadow="false" 
                        styleEditor="min-height: 20px;width: auto;" 
                        :content="info.optionsE" 
                        :subfield="false" 
                        :toolbarsFlag="false" 
                        previewBackground="#fff"
                        defaultOpen="preview" 
                    /></span>
                </Radio>
                <Radio :label="'F'" v-if="info.optionsF">
                    <div>F、</div>
                    <mavonEditor 
                        :boxShadow="false" 
                        styleEditor="min-height: 20px;width: auto;" 
                        :content="info.optionsF" 
                        :subfield="false" 
                        :toolbarsFlag="false" 
                        previewBackground="#fff"
                        defaultOpen="preview" 
                    /></span>
                </Radio>
            </Radio-group>
        </div>
        <div v-if="isView">
            <div class="right-key"><span>正确答案：{{correctAnswer}} </span> <span @click="showResolute">显示解析</span></div>
            <div class="resolve" v-if="showResolutionBox" >
                <div class="text" v-if="txtSolution">
                    <div style='color:#FF9D00'>文字解析：</div>
                    <div v-html="txtSolution"></div>
                </div>
                <div class="video" v-if="videoSolution">
                    <div>视频解析：</div>
                    <video :src="videoSolution" controls></video>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import mavonEditor from './mavonEditor.vue'
export default {
    components:{ mavonEditor },
    props:{
        info:{
            type:Object,
            default:null
        },
        correctAnswer:{
            type:String,
            default:null
        },
        yourAnswer:{
            type:String,
            default:null
        },
        isView:{
            type:Boolean,
            default:null
        },
        txtSolution:{
            type:String,
            default:null
        },
        videoSolution:{
            type:String,
            default:null
        },
    },
    data(){
        return{
            singleAnwer:'',
            showResolutionBox: false,
        }
    },
    mounted(){
        this.singleAnwer = null
        if(this.yourAnswer){
            this.singleAnwer = this.yourAnswer
        }
    },
    watch:{
        
    },
    methods:{
        showResolute(){
            this.showResolutionBox = !this.showResolutionBox
        },
        change(){
            this.$emit('childQuestionFn', {answer:this.info.yourAnswer, questionId: this.info.id});
        }
    }
}
</script>
<style lang="less" scoped>
@import './style/common.less';

.single {
    margin-left: 60px;
    /deep/ .ivu-radio-wrapper {
        display: flex;
        margin: 10px 0 10px 10px;
        height: auto;
        span:nth-child(2) {
            display: inline-flex;
        }
        .ivu-radio {
            margin-top: 8px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/practise/components/questionSingle.vue